import React, {Component} from "react";
import {connect} from "react-redux";
import {setUser} from "../../store/actions";


/**
 * @class
 */
const Logout = class extends Component {
    componentDidMount() {
        // reset store state:
        // TODO: might want to use a root reducer instead of manually resetting state <https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store>
        this.props.dispatch(setUser({
            user: {},
            isLoggedIn: false
        }));

        // "delete" the authentication cookie -- we do this by making the cookie expired:
        const COOKIE_NAME = 'sails.sid'; // Sails' generated authentication cookie name
        document.cookie = `${COOKIE_NAME}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;Domain=.${document.domain}`;
    }

    render() {
        return <div></div>;
    }
};


// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user,
        isLoggedIn: state.isLoggedIn
    };
};

export default connect(mapStateToProps)(Logout);
